import { BiGlasses } from "react-icons/bi";
import { MdFormatAlignJustify } from "react-icons/md";
import { Link } from "react-router-dom";

const navData = [
  {
    id: "13ser2",
    name: "All",
    url: "/",
  },
  {
    id: "3432",
    name: "Pending",
    url: "/pending",
  },
  {
    id: "13234",
    name: "Complete",
    url: "/complete",
  },
  {
    id: "1334",
    name: "Canceled",
    url: "/",
  },
];

const orders = [
  {
    id: 1,
    name: "John Doe",
    date: "2023-05-10",
    tracking: "complete",
    amount: 50.99,
  },
  {
    id: 2,
    name: "Jane Smith",
    date: "2023-05-09",
    tracking: "canceled",
    amount: 75.5,
  },
  {
    id: 3,
    name: "Bob Johnson",
    date: "2023-05-12",
    tracking: "pending",
    amount: 100.0,
  },
  {
    id: 4,
    name: "Sara Lee",
    date: "2023-05-08",
    tracking: "on the way",
    amount: 25.0,
  },
];

const Orders = () => {
  return (
    <div className=" px-[10px] md:px-[20px] lg:px-[3%]">
      <Link to="/admin">
        <img className=" h-16" src="/utils/back.png" alt="" />
      </Link>
      <div className="flex justify-between w-full mb-5">
        {/* Nav for orders */}
        <div className="">
          <ul className="flex flex-row  flex-wrap">
            {navData.map((data) => {
              return (
                <li
                  key={data.id}
                  className={`mx-[2px] text-[10px] lg:mx-2  border-b`}
                >
                  {data.name}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="search px-3">
          <form
            //   onSubmit={onSubmit}
            className="search flex flex-row justify-center items-center "
          >
            <input
              type="text"
              placeholder="Search Order "
              className=" text-gray-300 text-sm w-36 Lg:w-44 md:w-60 bg-white rounded px-2 py-1 mx-2 outline-none"
            />
            <button className=" -ml-10 ">
              <megn className="text-2xl cursor-pointer" />
            </button>
          </form>

          <div className="filter"></div>
        </div>
      </div>

      {/* Table form here */}

      <div className=" w-[100vw]  lg:w-full  overflow-x-scroll scrollbar-hidden mb-20 px-2 ">
        <table className="min-w-full divide-y divide-gray-200 bg-BlueDark">
          <thead className="bg-white">
            <tr className="">
              <th
                scope="col"
                className="px-1 lg:px-6 py-3  text-[10px] md:text-sm lg:text-lgs font-medium text-Light uppercase tracking-wider text-center"
              >
                ID
              </th>
              <th
                scope="col"
                className="px-1 lg:px-6 py-3  text-[10px] md:text-sm lg:text-lgs font-medium text-Light uppercase tracking-wider text-center"
              >
                Name
              </th>
              <th
                scope="col"
                className="px-1 lg:px-6 py-3  text-[10px] md:text-sm lg:text-lgs font-medium text-Light uppercase tracking-wider text-center"
              >
                Date
              </th>
              <th
                scope="col"
                className="px-1 lg:px-6 py-3  text-[10px] md:text-sm lg:text-lgs font-medium text-Light uppercase tracking-wider text-center"
              >
                Tracking
              </th>
              <th
                scope="col"
                className="px-1 lg:px-6 py-3  text-[10px] md:text-sm lg:text-lgs font-medium text-Light uppercase tracking-wider text-center "
              >
                Amount
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {orders.map((order) => (
              <tr key={order.id} className="text-Light">
                <td className="px-1 lg:px-6 py-4 whitespace-nowrap">
                  <div className="text-[10px] md:text-sm lg:text-lgs text-center ">
                    {order.id}
                  </div>
                </td>
                <td className="px-1 lg:px-6 py-4 whitespace-nowrap">
                  <div className="text-[10px] md:text-sm lg:text-lgs text-center">
                    {order.name}
                  </div>
                </td>
                <td className="px-1 lg:px-6 py-4 whitespace-nowrap">
                  <div className="text-[10px] md:text-sm lg:text-lgs text-center ">
                    {order.date}
                  </div>
                </td>
                <td className="px-1 lg:px-6 py-4 whitespace-nowrap flex justify-center items-center">
                  <div
                    className={`text-[10px] md:text-sm lg:text-lgs  cursor-pointer   text-center rounded-xl px-2 ${
                      order.tracking === "complete" && "bg-green-600 text-white"
                    } 
                     ${order.tracking === "canceled" && "bg-red-500 text-white"}
                      ${order.tracking === "pending" && "bg-green-300"}
                     ${
                       order.tracking === "on the way" &&
                       "bg-green-400 text-white"
                     }
                      `}
                  >
                    {order.tracking}
                  </div>
                </td>
                <td className="px-1 lg:px-6 py-4 whitespace-nowrap">
                  <div
                    className={`text-[10px] md:text-sm lg:text-lgs text-center `}
                  >
                    {order.amount}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Orders;
